import { GridColDef } from '@mui/x-data-grid';
import {
  HandlersClinResponse,
  HandlersProjectClinResponse,
  useDeleteApiProjectsByIdClinsAndClinIdMutation,
  useGetApiClinsQuery,
  useGetApiProjectsByIdClinsQuery,
  usePostApiProjectsByIdClinsMutation,
} from '../../../../app/athenaApiGen';
import AdminPatternBJoinPanel from '../AdminPatternBJoinPanel';

const columns: GridColDef<HandlersProjectClinResponse>[] = [
  { field: 'clinCode', headerName: 'CLIN', flex: 0.7 },
  { field: 'clinTitle', headerName: 'Title', flex: 1.5 },
];

const AdminProjectCLINsPanel = () => (
  <AdminPatternBJoinPanel<HandlersProjectClinResponse, HandlersClinResponse>
    tableName="Project CLIN"
    apiPath="/api/projects/{id}/clins"
    parentType="project"
    useList={(parentId) =>
      useGetApiProjectsByIdClinsQuery({ id: parentId }, { skip: !parentId })
    }
    useAdd={usePostApiProjectsByIdClinsMutation}
    useRemove={useDeleteApiProjectsByIdClinsAndClinIdMutation}
    buildAddArg={(parentId, child) => ({
      id: parentId,
      handlersAddProjectClinRequest: { clinId: child.clinId ?? '' },
    })}
    buildRemoveArg={(parentId, row) => ({
      id: parentId,
      clinId: row.clinId ?? '',
    })}
    // CLIN list endpoint accepts a programId filter; passing undefined returns
    // all CLINs the user can see (server-side ACL filters). The cross-program
    // guard on POST will reject mismatches.
    useChildList={() => useGetApiClinsQuery({})}
    childPkAccessor="clinId"
    childLabelAccessor="clinCode"
    joinChildIdAccessor="clinId"
    columns={columns}
  />
);

export default AdminProjectCLINsPanel;
